
const API_BASE = process.env.REACT_APP_API_BASE || '/.netlify/functions/api';
const BASE = `${API_BASE}/academic-planner`;

function authHeaders() {
  const token =
    typeof window !== 'undefined'
      ? window.localStorage.getItem('authToken') || ''
      : '';
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}

async function apiFetch(url, options = {}) {
  const res = await fetch(url, {
    credentials: 'include',
    ...options,
    headers: { ...authHeaders(), ...(options.headers || {}) },
  });

  if (res.status === 401) {
    const err = new Error('unauthorized');
    err.status = 401;
    throw err;
  }

  const text = await res.text();
  if (!res.ok) {
    let message = `HTTP ${res.status}`;
    try {
      const parsed = JSON.parse(text);
      message = parsed?.message || parsed?.error || message;
    } catch {}
    const err = new Error(message);
    err.status = res.status;
    throw err;
  }

  try {
    return JSON.parse(text);
  } catch {
    return {};
  }
}

export const plannerService = {

  getAll: () => apiFetch(BASE),


  saveSettings: (settings) =>
    apiFetch(`${BASE}/settings`, {
      method: 'PUT',
      body: JSON.stringify(settings),
    }),


  createTask: (task) =>
    apiFetch(`${BASE}/tasks`, {
      method: 'POST',
      body: JSON.stringify(task),
    }),


  updateTask: (id, updates) =>
    apiFetch(`${BASE}/tasks/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(updates),
    }),


  deleteTask: (id) =>
    apiFetch(`${BASE}/tasks/${id}`, { method: 'DELETE' }),


  checkDeadlines: () =>
    apiFetch(`${BASE}/check-deadlines`, { method: 'POST' }),


  saveGoals: (goals) =>
    apiFetch(`${BASE}/goals`, {
      method: 'PUT',
      body: JSON.stringify({ goals }),
    }),


  saveWeekNote: (weekNum, note) =>
    apiFetch(`${BASE}/week-notes`, {
      method: 'PUT',
      body: JSON.stringify({ week_num: weekNum, note }),
    }),
};
